const REPLACED_SUBSTR = "рыночных финансовых инструментов";
const NEW_REPLACED_SUBSTR = "РФИ";

/** Заменить в названии ПИФ на РФИ */
export const replaceMfNameToShort = (name: string) =>
  name.replace(REPLACED_SUBSTR, NEW_REPLACED_SUBSTR);
